import TableSelectionDialog from './TableSelectionDialog';

export default TableSelectionDialog;
